module.exports = __webpack_public_path__ + "media/images/logo-6cda60e9b4b599d99127c94a7f335215.png";